import useModal from '@fipnooone/react-modal';
import React, { useEffect, useState } from 'react';

import { Api, Code } from '@.api';
import { ConsoleDev } from '@/Lib/ConsoleDev';

import { stationDetailStoreSelectors } from '../../../../../model/StationDetailStore';
import { StationTechnicalModeEnum } from '../../../../../model/StationTechnicalModeEnum';
import { ChambersModal } from '../ChambersModal';
import { ChambersModalEdit } from '../ChambersModalEdit';

export const useDeviceCard = () => {
    const [modal, modalControls] = useModal();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const stationTechnicalMode = stationDetailStoreSelectors.use.stationTechnicalMode();

    const startEditChambers = stationDetailStoreSelectors.use.startEditChambers();

    const iRomaStationWS = stationDetailStoreSelectors.use.iRomaStationWS();

    const showChambers = async (deviceId: number) => {
        setIsLoading(true);

        try {
            if (stationTechnicalMode === StationTechnicalModeEnum.OFF) {
                const response = await Api.devices().getChambers(deviceId);

                if (response.code === Code.Success) {
                    modalControls.set(<ChambersModal chambers={response.data.chambers} deviceId={deviceId} />);
                }
            } else {
                const chambersResponse = await startEditChambers(deviceId);

                modalControls.set(
                    <ChambersModalEdit
                        initialChambers={chambersResponse.chambers}
                        deviceId={deviceId}
                        onClose={() => modalControls.close()}
                        maximumSpritzes={chambersResponse.maximum_spritzes}
                    />
                );
            }
        } catch (error) {
            ConsoleDev.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (iRomaStationWS) {
            iRomaStationWS.onStationDisconnected(() => {
                modalControls.close();
                setIsLoading(false);
            });
        }
    }, [iRomaStationWS]);

    return {
        modal,
        isLoading,
        showChambers,
    };
};
